var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModalSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1628_2262",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 54,
    height: 56
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9994 4.99997L36.5656 9.78997L44.6944 9.77497L47.1906 17.51L53.7756 22.275L51.2494 30L53.7756 37.725L47.1906 42.49L44.6944 50.225L36.5656 50.21L29.9994 55L23.4331 50.21L15.3044 50.225L12.8081 42.49L6.22314 37.725L8.74939 30L6.22314 22.275L12.8081 17.51L15.3044 9.77497L23.4331 9.78997L29.9994 4.99997Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2495 30L27.4995 36.25L39.9995 23.75",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1628_2262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H60V60H0V0Z",
    fill: "#FFC700"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalSuccess);
export default __webpack_public_path__ + "static/media/modal_success.292a111fce00b96d58cffc4e937618fe.svg";
export { ForwardRef as ReactComponent };